<template>
  <div v-if="user" id="admin-user-edit" class="scroll-block">
    <form>
      <div class="row">
        <div class="col-12">
          <CNav variant="tabs" role="tablist">
            <CNavItem>
              <CNavLink
                href="javascript:void(0);"
                :active="tabPaneActiveKey === 1"
                @click="
                  () => {
                    tabPaneActiveKey = 1
                  }
                "
              >
                Общие
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                href="javascript:void(0);"
                :active="tabPaneActiveKey === 2"
                @click="
                  () => {
                    tabPaneActiveKey = 2
                  }
                "
              >
                Доступные камеры
              </CNavLink>
            </CNavItem>
          </CNav>
          <CTabContent>
            <CTabPane role="tabpanel" aria-labelledby="home-tab" :visible="tabPaneActiveKey === 1">
              <div class="row">
                <div class="col-12">
                  <div class="box">
                    <div class="box-body">
                      <div class="box-header border-bottom border-dark">
                        <div class="box-title">
                          <span class="mdi mdi-account-circle mdi-24px"></span>
                        </div>
                      </div>
                      <div class="box-body">
                        <div class="row">
                          <div class="col-md-12 col-lg-6">
                            <CFormLabel for="usernoautofill">Логин</CFormLabel>
                            <CInputGroup class="mb-3">
                              <CInputGroupText><i class="mdi mdi-account"></i></CInputGroupText>
                              <CFormInput
                                id="usernoautofill"
                                name="unoautofull"
                                :disabled="!register && afterRegister"
                                v-model="user.user"
                                autocomplete="off"
                              />
                            </CInputGroup>
                          </div>

                          <div class="col-md-12 col-lg-6">
                            <CFormLabel for="passwordnoautofill">Пароль</CFormLabel>
                            <CInputGroup class="mb-3">
                              <CInputGroupText
                                ><i class="mdi mdi-form-textbox-password"></i
                              ></CInputGroupText>
                              <CFormInput
                                id="passwordnoautofill"
                                name="pnoautofull"
                                v-model="user.password"
                                :disabled="lockedPass"
                                :type="showPass ? 'text' : 'password'"
                                autocomplete="off"
                              />
                              <CInputGroupText @click="toggleShowPass">
                                <i v-if="showPass" class="mdi mdi-eye-off"></i>
                                <i v-else class="mdi mdi-eye"></i>
                              </CInputGroupText>
                            </CInputGroup>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12 col-lg-6">
                            <CFormLabel for="emailnoautofill">Email</CFormLabel>
                            <CInputGroup class="mb-3">
                              <CInputGroupText><i class="mdi mdi-email"></i></CInputGroupText>
                              <CFormInput
                                id="emailnoautofill"
                                v-model="user.email"
                                autocomplete="off"
                              />
                            </CInputGroup>
                          </div>

                          <div class="col-md-12 col-lg-6">
                            <CFormLabel for="phonenoautofill">Телефон</CFormLabel>
                            <CInputGroup class="mb-3">
                              <CInputGroupText><i class="mdi mdi-email"></i></CInputGroupText>
                              <CFormInput
                                id="phonenoautofill"
                                v-model="user.phone"
                                autocomplete="off"
                              />
                            </CInputGroup>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12 col-lg-6">
                            <CFormLabel for="role">Права</CFormLabel>
                            <CInputGroup class="mb-3">
                              <CInputGroupText
                                ><i class="mdi mdi-shield-half-full"></i
                              ></CInputGroupText>
                              <CFormSelect
                                id="role"
                                v-model="user.role"
                                :disabled="!register && afterRegister"
                              >
                                <option value="0">Пользователь</option>
                                <option value="1">Администратор</option>
                              </CFormSelect>
                            </CInputGroup>
                          </div>

                          <div class="col-md-12 col-lg-6">
                            <CFormLabel for="statuses">Статус</CFormLabel>
                            <CInputGroup class="mb-3">
                              <CInputGroupText><i class="mdi mdi-group"></i></CInputGroupText>
                              <CFormSelect id="statuses" v-model="user.status">
                                <option
                                  v-for="status in statuses"
                                  :key="status.value"
                                  :selected="status.value === user.status"
                                  :value="status.value"
                                >
                                  {{ status.title }}
                                </option>
                              </CFormSelect>
                            </CInputGroup>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-12">
                            <div class="form-check px-0">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="user.sessionLimit"
                                id="sessionLimit"
                              />
                              <label class="form-check-label" for="sessionLimit">
                                Ограничивать сессию одним активным аккаунтом
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="box">
                    <div class="box-header border-bottom border-dark">
                      <div class="box-title">Адрес</div>
                    </div>

                    <div class="box-body">
                      <div class="row">
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label for="city">Город</label>
                            <input
                              id="city"
                              v-model="user.address.city"
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6 col-lg-4">
                          <div class="form-group">
                            <label for="street">Улица</label>
                            <input
                              id="street"
                              v-model="user.address.street"
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-3 col-lg-2">
                          <div class="form-group">
                            <label for="houseNum">Дом</label>
                            <input
                              id="houseNum"
                              v-model="user.address.houseNum"
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-3 col-lg-2">
                          <div class="form-group">
                            <label for="apartmentNum">Квартира</label>
                            <input
                              id="apartmentNum"
                              v-model="user.address.apartmentNum"
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6 col-lg-4">
                          <CFormLabel for="defaultDivisionnoautofill">Основная площадка</CFormLabel>
                          <div class="position-relative">
                            <CInputGroup>
                              <CInputGroupText
                                ><i class="mdi mdi-office-building"></i
                              ></CInputGroupText>
                              <CFormInput
                                id="divisionSearch"
                                v-model="divisionSearch"
                                placeholder="Поиск площадки..."
                                @focus="showDivisionDropdown = true"
                                autocomplete="off"
                              />
                            </CInputGroup>

                            <!-- Dropdown Menu -->
                            <div v-if="showDivisionDropdown" class="division-dropdown">
                              <div
                                v-for="div in filteredDefaultDivisions"
                                :key="div.guid"
                                class="dropdown-item py-2 px-3 cursor-pointer"
                                :class="{ active: user.defaultDivision === div.guid }"
                                @click="selectDefaultDivision(div)"
                              >
                                {{ div.name }}
                              </div>
                              <div
                                v-if="filteredDefaultDivisions.length === 0"
                                class="dropdown-item py-2 px-3"
                              >
                                Ничего не найдено
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="box">
                    <div class="box-header border-bottom border-dark">
                      <div class="box-title">Домофон</div>
                    </div>
                    <div class="box-body">
                    <div class="row">
                      <div class="col-md-12 mb-3 d-flex align-items-center gap-3">
                        <span
                          class="badge"
                          :class="extensionRegistered ? 'bg-success' : 'bg-danger'"
                          style="padding: 8px 16px; font-size: 14px;"
                        >
                          {{ extensionRegistered ? 'Номер зарегистрирован' : 'Номер не зарегистрирован' }}
                        </span>
                        <CButton
                          color="success"
                          type="button"
                          size="sm"
                          @click="handleRegisterExtension"
                          :disabled="!user.sipUsername || !user.sipPassword || !user.intercomDivision || !user.intercomName"
                        >
                          Зарегистрировать
                        </CButton>
                        <CButton
                          type="button"
                          color="info"
                          size="sm"
                          @click="handleRegisterRandomExtension"
                          :disabled="!user.intercomDivision || !user.intercomName || !user.address.apartmentNum"
                        >
                          Зарегистрировать случайный номер
                        </CButton>
                      </div>
                    </div>
                      <div class="row">
                        <div class="col-md-6 col-lg-4">
                          <CFormLabel for="intercomUserName">Имя пользователя</CFormLabel>
                          <CInputGroup class="mb-3">
                            <CInputGroupText><i class="mdi mdi-phone"></i></CInputGroupText>
                            <CFormInput
                              id="intercomUserName"
                              v-model="user.sipUsername"
                              autocomplete="off"
                            />
                          </CInputGroup>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <CFormLabel for="intercomPassword">Пароль</CFormLabel>
                          <CInputGroup class="mb-3">
                            <CInputGroupText
                              ><i class="mdi mdi-form-textbox-password"></i
                            ></CInputGroupText>
                            <CFormInput
                              id="intercomPassword"
                              v-model="user.sipPassword"
                              :type="showIntercomPass ? 'text' : 'password'"
                              autocomplete="off"
                            />
                            <CInputGroupText @click="showIntercomPass = !showIntercomPass">
                              <i v-if="showIntercomPass" class="mdi mdi-eye-off"></i>
                              <i v-else class="mdi mdi-eye"></i>
                            </CInputGroupText>
                          </CInputGroup>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 col-lg-4">
                          <CFormLabel for="sipServer">Сервер</CFormLabel>
                          <CInputGroup class="mb-3">
                            <CInputGroupText><i class="mdi mdi-server"></i></CInputGroupText>
                            <CFormInput
                              id="sipServer"
                              v-model="user.sipServer"
                              autocomplete="off"
                            />
                          </CInputGroup>
                        </div>
                        <div class="col-md-6">
                          <CFormLabel for="intercomName">Домофон</CFormLabel>
                          <span v-if="!Number.isNaN(emptyIntercomSlotsCount)" class="badge bg-danger">{{ emptyIntercomSlotsCount }} свободных {{ declOfNum(emptyIntercomSlotsCount, ['номер', 'номера', 'номеров']) }} в домофоне</span>
                          <span class="input-group">
                          <span class="input-group-text"><i class="mdi mdi-doorbell-video"></i></span>
                          <select class="form-select" id="intercomName" v-model="selectedIntercom">
                            <option value="">—</option>
                            <option v-for="intercom in intercoms" :key="intercomOptionValue(intercom)" v-bind:value="intercomOptionValue(intercom)">{{ intercom.divisionName }}/{{ intercom.intercomName }}</option>
                          </select>
                        </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CTabPane>
            <CTabPane role="tabpanel" aria-labelledby="home-tab" :visible="tabPaneActiveKey === 2">
              <div class="row">
                <div v-if="register && !afterRegister" class="col-12">
                  <div class="box-body text-center mt-3">
                    <p>Сначала нужно сохранить созданного пользователя</p>
                  </div>
                </div>
                <div v-else class="col-12">
                  <div class="box">
                    <CFormInput
                      id="searchnoautofill"
                      v-model="divisionFilter"
                      placeholder="Поиск по площадкам"
                      autocomplete="off"
                    />
                  </div>

                  <div class="box">
                    <div class="box-body">
                      <div class="division-selector2">
                        <div
                          v-for="division in filteredSortedDivisions"
                          :key="division['guid']"
                          class="division-item"
                        >
                          <div class="division-title">
                            <div class="division-check-box">
                              <input
                                :id="division['guid']"
                                v-model="division.selected"
                                type="checkbox"
                                class="filled-in chk-col-blue"
                                @change="selectDivision(division)"
                              />
                              <label :for="division['guid']" class=""></label>
                            </div>
                            <div class="division-name">
                              {{ division.name }}<br />
                              <!--<small class="text-purple">{{ division.address }}</small><br>
                              <small class="text-gray">server ver.: {{ division.version || '-' }}<br></small>
                              <small v-if="division.lastActivity" class="text-gray">последняя активность: {{ division.lastActivity }}<br></small>-->
                            </div>

                            <div class="division-item__btn">
                              <CButton
                                color="secondary"
                                class="btn-cam"
                                @click.prevent="openCamSelectop(division)"
                                ><i class="mdi mdi-video"></i>
                              </CButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CTabPane>
          </CTabContent>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="box">
            <div class="box-body">
              <div class="row">
                <div class="col-12 d-flex justify-content-end">
                  <div class="btn btn-default btn-lg mx-3" @click="hide">Отмена</div>
                  <div class="btn btn-success btn-lg" @click="saveUser">Сохранить</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <CModal
      scrollable
      :visible="selectorModalShow"
      @close="
        () => {
          selectorModalShow = false
        }
      "
    >
      <CModalHeader>
        <CModalTitle>Камеры</CModalTitle>
      </CModalHeader>
      <CModalBody v-if="editeddevision">
        <h3 class="mb-3 text-white">{{ editeddevision.name }}</h3>
        <div class="row">
          <CButtonGroup size="sm" class="mx-auto">
            <CButton :color="cameraModalMode === 'camera' ? 'success' : 'outline'" class="btn-cam" @click="cameraModalMode = 'camera'">Камеры</CButton>
            <CButton :color="cameraModalMode === 'intercom' ? 'success' : 'outline'" class="btn-cam" @click="cameraModalMode = 'intercom'">Домофоны</CButton>
          </CButtonGroup>
        </div>
        <div class="row mb-3">
          <div class="col-12 small">
            <span class="text-info" @click="checkAll(true)">Выбрать все</span> /
            <span class="text-warning" @click="checkAll(false)">Отменить все</span>
          </div>
        </div>

        <div class="row" v-if="cameraModalMode === 'camera'">
          <div
            v-for="(cam, idxCam) of editeddevision.camList"
            :key="idxCam"
            class="col-6 mb-2 border-bottom border-dark"
          >
            <input
              :id="editeddevision.guid + '-' + cam.name + '-' + idxCam"
              v-model="cam.selected"
              type="checkbox"
              class="with-gap"
              @change="selectCam(editeddevision)"
            />
            <label
              :for="editeddevision.guid + '-' + cam.name + '-' + idxCam"
              class="filled-in chk-col-light-blue"
            >
              {{ cam.name }}
            </label>
          </div>
        </div>


        <div class="row" v-if="cameraModalMode === 'intercom'">
          <div
            v-for="(intercom, idxIntercom) of editeddevision.intercomList"
            :key="idxIntercom"
            class="col-6 mb-2 border-bottom border-dark"
          >
            <input
              :id="editeddevision.guid + '-' + intercom + '-' + idxIntercom"
              v-model="intercom.selected"
              type="checkbox"
              class="with-gap"
              @change="selectIntercom(editeddevision)"
            />
            <label
              :for="editeddevision.guid + '-' + intercom + '-' + idxIntercom"
              class="filled-in chk-col-light-blue"
            >
              {{ intercom.name }}
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <CButton
              color="success"
              @click="
                () => {
                  selectorModalShow = false
                }
              "
              >OK</CButton
            >
          </div>
        </div>
      </CModalBody>
    </CModal>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeMount, onBeforeUnmount, watch } from 'vue'
import User from '@/services/user'
import {
  CTabContent,
  CButton,
  CTabPane,
  CNavLink,
  CFormSelect,
  CNavItem,
  CNav,
  CButtonGroup,
  CFormLabel,
  CInputGroup,
  CFormInput,
  CInputGroupText,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from '@coreui/bootstrap-vue'
import { ApiSys } from '@/services/api'
import MD5 from 'md5'
import { passGen } from '@/helpers/utils'
import { useToast } from 'vue-toast-notification'
import { debounce } from 'lodash-es'
const props = defineProps({
  division: {
    type: Object,
    required: true
  },
  username: String,
  hide: Function,
  register: Boolean
})

const toast = useToast()

// Reactive state
const user = ref(null)
const usernameInternal = ref('')
const lockedPass = ref(false)
const showPass = ref(false)
const showIntercomPass = ref(false)
const allDivisionsServer = ref([])
const allDivisionsRaw = ref([])
const allDivisions = ref([])
const editeddevision = ref(null)
const tabPaneActiveKey = ref(1)
const divisionFilter = ref('')
const selectorModalShow = ref(false)
const afterRegister = ref(false)
const divisionSearch = ref('')
const showDivisionDropdown = ref(false)
const extensionRegistered = ref(false)
const intercoms = ref([])
const emptyIntercomSlotsCount = ref(NaN)
const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'
const intercomFilter = ref('')
const cameraModalMode = ref('camera')

// Computed properties
const normalizeIntercomValue = (value) => String(value ?? '').trim().toLowerCase()
const intercomOptionValue = (intercom) => `${intercom.divisionUuid}/${intercom.intercomName}`

const declOfNum = (num, words) => {
  const cases = [2, 0, 1, 1, 1, 2]
  return words[ (num % 100 > 4 && num % 100 < 20) ? 2 : cases[(num % 10 < 5) ? num % 10 : 5] ]
}


const selectedIntercom = computed({
  get() {
    const intercomDivision = user.value?.intercomDivision ?? user.value?.IntercomDivision
    const intercomName = user.value?.intercomName ?? user.value?.IntercomName

    if (!intercomDivision || !intercomName) {
      return ''
    }
    if (String(intercomDivision).toLowerCase() === EMPTY_GUID) {
      return ''
    }

    const selectedIntercom = intercoms.value.find(
      (intercom) =>
        normalizeIntercomValue(intercom.divisionUuid) === normalizeIntercomValue(intercomDivision) &&
        normalizeIntercomValue(intercom.intercomName) === normalizeIntercomValue(intercomName)
    )

    return selectedIntercom ? intercomOptionValue(selectedIntercom) : `${intercomDivision}/${intercomName}`
  },
  set(value) {
    if (!user.value) {
      return
    }
    if (!value) {
      user.value.intercomDivision = null
      user.value.intercomName = null
      return
    }
    const slashIdx = value.indexOf('/')
    user.value.intercomDivision = value.slice(0, slashIdx)
    user.value.intercomName = value.slice(slashIdx + 1)
  }
})

const statuses = computed(() => [
  {
    title: 'Активный',
    value: 'Active'
  },
  {
    title: 'Неактивный',
    value: 'Inactive'
  },
  {
    title: 'Удаленный',
    value: 'Deleted'
  }
])

let emptyIntercomSlotsFetchId = 0

async function fetchEmptyIntercomSlots(intercomDivision, intercomName, apartmentNum) {
  const fetchId = ++emptyIntercomSlotsFetchId
  const response = await ApiSys.getEmptyIntercomSlots(intercomDivision, intercomName, apartmentNum)
  if (fetchId !== emptyIntercomSlotsFetchId) {
    return
  }
  if (response.error) {
    //toast.error(response.error.message)
    return
  }
  emptyIntercomSlotsCount.value = response
}

const debouncedFetchEmptyIntercomSlots = debounce(fetchEmptyIntercomSlots, 300)

watch(
  [
    () => user.value?.intercomDivision,
    () => user.value?.intercomName,
    () => user.value?.address?.apartmentNum
  ],
  ([intercomDivision, intercomName, apartmentNum]) => {
    if (!intercomDivision || !intercomName || !apartmentNum) {
      debouncedFetchEmptyIntercomSlots.cancel()
      emptyIntercomSlotsCount.value = NaN
      return
    }
    debouncedFetchEmptyIntercomSlots(intercomDivision, intercomName, apartmentNum)
  }
)

onBeforeUnmount(() => {
  debouncedFetchEmptyIntercomSlots.cancel()
})

const filteredDivisions = computed(() => {
  return divisionFilter.value.length
    ? allDivisions.value.filter((u) =>
        u.name.toLowerCase().includes(divisionFilter.value.toLowerCase())
      )
    : allDivisions.value
})

const filteredDefaultDivisions = computed(() => {
  return divisionSearch.value.length
    ? allDivisions.value.filter((u) =>
        u.name.toLowerCase().includes(divisionSearch.value.toLowerCase())
      )
    : allDivisions.value
})

const filteredSortedDivisions = computed(() => {
  const deepCloned = [...filteredDivisions.value]

  deepCloned.sort((a, b) => {
    const smallA = String(a.name).toLowerCase()
    const smallB = String(b.name).toLowerCase()

    if (smallA < smallB) {
      return -1
    }
    if (smallA > smallB) {
      return 1
    }
    return 0
  })

  return deepCloned
})

const filteredSortedIntercoms = computed(() => {
  return intercoms.value;
  const deepCloned = [...intercoms.value]
  if (intercomFilter.value.length) {
    return deepCloned.filter((intercom) => {
      return intercom.name.toLowerCase().includes(intercomFilter.value.toLowerCase())
    })
  }
  return deepCloned
})

// Methods
async function updateDate() {
  await get()
  await prepareDivisions()
  await fetchEmptyIntercomSlots(user.value?.intercomDivision, user.value?.intercomName, user.value?.address?.apartmentNum)
  allDivisionsRaw.value = [...allDivisions.value]
}

async function checkExtensionStatus() {
  if (!user.value?.sipUsername) {
    extensionRegistered.value = false
    return
  }

  try {
    const response = await ApiSys.extensionExists(user.value.sipUsername)
    if (response.error) {
      extensionRegistered.value = false
      return
    }
    extensionRegistered.value = response.extension === user.value.sipUsername
  } catch (error) {
    console.error('Error checking extension status:', error)
    extensionRegistered.value = false
  }
}

async function get() {
  if (props.register && !afterRegister.value) {
    user.value = {
      user: null,
      password: passGen(),
      email: null,
      divisions: [],
      address: {
        city: null,
        street: null,
        houseNum: null,
        apartmentNum: null
      },
      role: 0,
      sessionLimit: false,
      group: null,
      intercomDivision: null,
      intercomName: null
    }
    const intercomsResponse = await ApiSys.getIntercoms()
    if (!intercomsResponse.error) {

      intercoms.value = intercomsResponse.flatMap(division =>
        (division.intercomList ?? []).map(intercom => ({
          divisionName: division.name,
          divisionUuid: division.guid,
          intercomName: intercom,
        }))
      )
    }
  } else {
    const response = await ApiSys.getUser({ user: usernameInternal.value })
    if (response.error) {
      toast.error(response.error.message)
    }
    user.value = response.data
    if (!user.value.address) {
      user.value.address = {
        city: null,
        street: null,
        houseNum: null,
        apartmentNum: null
      }
    }
    const intercomsResponse = await ApiSys.getIntercoms()
    if (!intercomsResponse.error) {

      intercoms.value = intercomsResponse.flatMap(division =>
        (division.intercomList ?? []).map(intercom => ({
          divisionName: division.name,
          divisionUuid: division.guid,
          intercomName: intercom,
        }))
      )
    }
    await checkExtensionStatus()
  }
}

async function saveNewUser() {
  user.value.divisionUuid = props.division.id
  user.value.name = user.value.user
  let result = await ApiSys.adminRegisterUser({
    ...user.value,
    password: MD5(user.value.password)
  })

  if (result.error) {
    toast.error(result.error.message)
    return false
  }
  toast.success('Пользователь успешно сохранен')

  return true
}

function selectDefaultDivision(division) {
  user.value.defaultDivision = division.guid
  divisionSearch.value = division.name
  showDivisionDropdown.value = false
}

async function saveCreatedUser() {
  const userDivisions = allDivisions.value
    .filter((e) => e.selected)
    .map((e) => {
      const camList = e.camList.filter((c) => c.selected).map((c) => c.name)
      const intercomList = e.intercomList.filter((i) => i.selected).map((i) => i.name)
      return { divisionUuid: e.guid, camList, intercomList }
    })
  if (userDivisions.length === 0) {
    const conf = confirm("У пользователя нет доступных объектов, если вы продолжите, то ему будет присвоен статус 'Неактивный'")
    if (!conf) {
      return
    }
    user.value.status = 'Inactive'
  }
  const savedUser = Object.assign({}, user.value)
  savedUser.divisionsWithCams = userDivisions
  savedUser.divisionsOp = 'replace'

  savedUser.status = statuses.value.indexOf(
    statuses.value.find((s) => s.value === user.value.status)
  )
  delete savedUser.divisions
  const response = await ApiSys.patchUserAdmin(user.value.user, savedUser)
  if (response.error) {
    toast.error(response.error.message)
  } else {
    toast.success('Пользователь успешно сохранен')
  }
}

async function saveUser() {
  if (props.register && !afterRegister.value) {
    const res = await saveNewUser()
    if (res) {
      usernameInternal.value = user.value.user
      afterRegister.value = true
      updateDate()
    }
  } else {
    await saveCreatedUser()
  }
}

async function prepareDivisions() {
  if (props.register && !afterRegister.value) {
    allDivisionsServer.value = await ApiSys.getAdminDivisions()
    allDivisions.value = allDivisionsServer.value;
    return
  }
  allDivisionsServer.value = await ApiSys.getAdminDivisions()
  allDivisions.value = User.prepareViewDivisions([...allDivisionsServer.value], user.value)
  allDivisions.value.forEach((division) => {
    selectCam(division)
  })
  if (user.value.defaultDivision) {
    selectDefaultDivision(allDivisions.value.find((d) => d.guid === user.value.defaultDivision))
  }
}

function toggleShowPass() {
  showPass.value = !showPass.value
}

function selectDivision(division) {
  let newStatus = division.selected
  division.camList.map(function (cam) {
    cam.selected = newStatus
    return cam
  })
}

/**
 * помечаем дивижн если хоть одна камер выбран
 *
 * @param division
 */
function selectCam(division) {
  const userSameDivision = allDivisions.value.find((d) => d.guid === division.guid)

  if (userSameDivision) {
    division.selected = userSameDivision.camList.some((e) => e.selected)
  } else {
    division.selected = false
  }
}

function selectIntercom(division) {
  const userSameDivision = allDivisions.value.find((d) => d.guid === division.guid)
  if (userSameDivision) {
    division.selected = userSameDivision.intercomList.some((e) => e.selected)
  } else {
    division.selected = false
  }
}

function openCamSelectop(division) {
  console.log(division)
  editeddevision.value = division
  selectorModalShow.value = true
}

function checkAll(all) {
  editeddevision.value.camList.map(function (cam) {
    cam.selected = !!all
    return cam
  })
  const userSameDivision = allDivisions.value.find((d) => d.guid === editeddevision.value.guid)
  if (userSameDivision) {
    userSameDivision.selected = userSameDivision.camList.some((e) => e.selected)
  } else {
    userSameDivision.selected = false
  }
}

async function handleRegisterExtension() {
  if (props.register && !afterRegister.value) {
    toast.error("Пользователь еще не зарегистрирован!");
    return;
  }
  if (!user.value.sipUsername || !user.value.sipPassword) {
    toast.error('Заполните имя пользователя и пароль')
    return
  }
  if (!user.value.intercomDivision || !user.value.intercomName) {
    toast.error('Выберите домофон')
    return
  }

  try {
    const response = await ApiSys.registerExtension({
      extension: user.value.sipUsername,
      password: user.value.sipPassword,
      intercom_division: user.value.intercomDivision,
      intercom_name: user.value.intercomName,
      user_context: 'default'
    })
    if (response.error) {
      toast.error(response.data || 'Ошибка при регистрации номера')
      return
    }
    const server = user.value.sipServer ?? "sip.pervaya1.ru";
      const resp = await ApiSys.patchUserAdmin(user.value.user, {sipUsername: user.value.sipUsername, sipPassword: user.value.sipPassword, sipServer: server})
      if (resp.error) {
        toast.error('Не удалось cохранить пользователя')
        return;
      }
      await updateDate();
    toast.success('Номер успешно зарегистрирован')
  } catch (error) {
    toast.error('Ошибка при регистрации номера')
    console.error(error)
  }
}

async function handleRegisterRandomExtension() {
  if (props.register && !afterRegister.value) {
    toast.error("Пользователь еще не зарегистрирован!");
    return;
  }
  if (!user.value.intercomDivision || !user.value.intercomName) {
    toast.error('Выберите домофон')
    return
  }
  try {
    const response = await ApiSys.registerRandomExtension({
      username: user.value.user,
      email: user.value.email,
      intercomDivision: user.value.intercomDivision,
      intercomName: user.value.intercomName,
      city: user.value.address.city,
      street: user.value.address.street,
      houseNum: user.value.address.houseNum,
      apartmentNum: user.value.address.apartmentNum,
    })
    if (response.error) {
      toast.error(response.message || response.error?.message || 'Ошибка при регистрации случайного номера')
      return
    }

    if (response?.extension) {
      const server = response.server ?? "sip.pervaya1.ru";
      const resp = await ApiSys.patchUserAdmin(user.value.user, {sipUsername: response.extension, sipPassword: response.password, sipServer: server})
      if (resp.error) {
        toast.error('Не удалось cохранить пользователя')
        return;
      }
      await updateDate();
      toast.success(`Случайный номер ${response.extension} успешно зарегистрирован`)
    } else {
      toast.error('Не удалось получить номер из ответа')
    }
  } catch (error) {
    toast.error('Ошибка при регистрации случайного номера')
    console.error(error)
  }
}

// Watch for sipUsername changes to check extension status
watch(
  () => user.value?.sipUsername,
  async (newValue) => {
    if (newValue) {
      await checkExtensionStatus()
    } else {
      extensionRegistered.value = false
    }
  }
)

// Lifecycle hooks
onBeforeMount(async () => {
  await User.checkAdmin()
})

onMounted(() => {
  usernameInternal.value = props.username
  updateDate()
})
</script>

<style lang="stylus" scoped>
#admin-user-edit {
  padding: 10px
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100% - 50px);

  a {
        color : #ccc
      }
      a:hover {
        text-decoration: none;
      }
  a:not(.active):hover {
    color : #000;
  }
}


.division-selector2 {
  display: flex
  justify-content: space-between
  flex-wrap: wrap

  .division-item {
    width: 32%
    margin: 0 1% 1% 0
    background: #383e47
    padding: 8px

    .division-title {
      overflow: hidden
      display: flex
      margin-bottom: 10px
      position: relative

      .division-check-box {
        float: left;
        width: 30px
      }

      .division-name {
        color: #fff;
        flex-grow: 1;
        word-break: break-all
      }
      .btn-cam, .btn-select-group, .btn-star {
        // position: absolute;
        top: 0;
        right: 0;
        text-align: center;
        font-size: 24px;
        width: 34px;
        padding: 0;
        height: 32px;
        line-height: 0px;
      }

    }
  }

  .division-item__btn {
    display flex;
    flex-direction: column
  }
}


.small-screen {

  .division-selector2 {
    display: block

    .division-item {
      width: 100%
    }
  }


}

.dropdown-item {
  &:hover {
    background-color: #343a40
  }

  &.active {
    background-color: #2f3438
  }
}

.division-dropdown {
  position: absolute;
  width: 100%;
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  background-color: #272c33;
  border-radius: 0.375rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.47);
}


/*.division-selector {

  label.division-name {
    line-height: 18px;
    height: auto;
    word-break break-word
  }

  .sub {
    margin-left: 20px

    label {
      height: 20px
      line-height: 20px
    }
  }
}*/
</style>
